<template>
  <div class="save-popup--spacer">
  <span class="button--inverted">
    Save
  </span>
</div>
</template>
